import Observer from 'common/scripts/observer';
import Slider from 'components/slider';

const observer = new Observer();

const startTagSlider = () => {
    const tagSliders = document.querySelectorAll('.j-tag-slider');

    if (tagSliders.length) {
        tagSliders.forEach((slider) => {
            if (!slider.querySelector('.j-tag-slider__slides.is-slider-ready')) {
                new Slider({
                    elem     : slider.querySelector('.j-tag-slider__slides'),
                    controls : slider.querySelector('.j-tag-slider__controls'),
                    prevArrow: slider.querySelector('.j-slider__prev'),
                    nextArrow: slider.querySelector('.j-slider__next'),
                    counter  : slider.querySelector('.j-slider__counter'),
                    settings : {
                        infinite     : false,
                        speed        : 500,
                        slidesToShow : 1,
                        variableWidth: true,
                        responsive   : [{
                            breakpoint: 960,
                            settings  : {
                                autoplay: false,
                                infinite: false
                            }
                        }]
                    }
                }).init();
            }
        });
    }
};

startTagSlider();

observer.subscribe('parametric:setResult', startTagSlider);
